import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';


function SubjectTooltipTable({ tooltipList }) {

    return (
        <>
            <Table
                size="small"
                aria-label="subject table"
                sx={{
                    borderCollapse: 'collapse',
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{ fontSize: '10px', padding: '2px', lineHeight: 1 }}
                        >
                            Ad
                        </TableCell>
                        <TableCell
                            sx={{ fontSize: '10px', padding: '2px', lineHeight: 1 }}
                            align="right"
                        >
                            Gündem Sayısı
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tooltipList.length > 0 ? (
                        tooltipList.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell
                                    sx={{ fontSize: '10px', padding: '2px', lineHeight: 1 }}
                                >
                                    {item.name}
                                </TableCell>
                                <TableCell
                                    sx={{ fontSize: '10px', padding: '2px', lineHeight: 1 }}
                                    align="right"
                                >
                                    {item.count}
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell
                                colSpan={2}
                                align="center"
                                sx={{ fontSize: '10px', padding: '2px', lineHeight: 1 }}
                            >
                                Kayıt bulunamadı
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </>
    );
}

export default SubjectTooltipTable;
